import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-lg text-sm font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 px-3 py-1",
  {
    variants: {
      variant: {
        default: "bg-accent text-primary-foreground hover:bg-accent-hover",
        secondary: "bg-c-gray-600 text-white hover:bg-accent-hover",
        destructive:
          "bg-c-red-500 text-destructive-foreground hover:bg-c-red-600",
        "secondary-light": "bg-c-gray-500 text-white hover:bg-accent-hover",
        ghost: "hover:bg-c-gray-500 hover:text-white",
        outline: "border border-c-gray-400 bg-transparent hover:bg-c-gray-500",
        link: "text-accent underline-offset-4 hover:underline",
      },
      size: {
        default: "h-auto",
        sm: "h-8 px-2 text-xs",
        lg: "h-11 px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
